import theme from '../../../theme/theme';

/** Toolbar height from the MUI theme — used to offset a right drawer below the navbar. */
export const NAVBAR_HEIGHT = theme.mixins.toolbar.minHeight as number; // 64px desktop
